import React from "react";

import Image from "./Global/Image";

import src from "../images/masthead.png";
import srcRet from "../images/masthead@2x.png";
import webp from "../images/masthead.webp"
import webpRet from "../images/masthead@2x.webp"

import puceSrc from "../images/puce-01.jpg";
import puceSrcRet from "../images/puce-01@2x.jpg";
import puceWebp from "../images/puce-01.webp";
import puceWebpRet from "../images/puce-01@2x.webp";

//Image mobile

import srcMobile from "../images/mobile/masthead.jpg";

import styles from "./Masthead.module.scss";
import Button from "./Global/Button";
import Arrow from "./Pictos/Arrow";

export default function Masthead() {
    return (
        <section className={styles.Main}>
            <div className={styles.Masthead}>
                <Image {...{src, srcRet, webp, webpRet}} mobile={srcMobile}/>

                <div className={'container'}>
                    <h1 className={styles.Title}>
                        <strong>
                            Les semi-conducteurs,
                        </strong>
                        Le nouvel «&nbsp;or noir&nbsp;» de l’électronique
                    </h1>

                    <div className={styles.ButtonWrapper}>
                        <Arrow/>

                        <Button url={"https://ad.doubleclick.net/ddm/clk/507510052;314764148;y"} text={'Investissez'}/>
                    </div>
                </div>
            </div>


            <div className={'container'}>
                <p className={['head-text', styles.HeadText].join(' ')}>
                    Dans les voitures, les ordinateurs, les smartphones, les téléviseurs, les consoles de jeux vidéo…
                    Les semi-conducteurs, ces puces électroniques presque invisibles sans lesquelles il serait
                    impossible de faire circuler des informations dans les machines, sont nichés dans une multitude
                    d’objets du quotidien. L’an dernier, plus de 1.000 milliards de puces ont été vendues dans le monde
                    entier.
                </p>
            </div>

            <div className={'container'}>
                <div className={styles.Figures}>
                    <div className={styles.FiguresText}>
                        <p>
                            <strong>Devenus véritablement indispensables à de nombreux secteurs, les semi-conducteurs
                                représentaient en 2020 un marché de plus de 440 milliards de dollars dans le monde.</strong>
                        </p>

                        <p>
                            En 2021, il pourrait atteindre 522 milliards de dollars. Et la tendance ne devrait pas
                            s’inverser : le marché devrait croître de 8,6% par an, pour atteindre 800 milliards de dollars
                            d’ici 2028, avec une croissance robuste et continue notamment pour les marchés grand public,
                            informatique, 5G et automobile.
                        </p>

                    </div>
                    <div className={styles.FiguresWrapper}>
                        <div className={[styles.FigureCard, 'bg-green'].join(' ')}>
                            <p>
                                En 2021, un marché de plus de
                            </p>

                            <span>
                                522
                                <small>
                                    milliards de dollars
                                </small>
                            </span>
                        </div>

                        <div className={[styles.FigureCard, 'bg-blue'].join(' ')}>
                            <p>
                                Une croisssance estimée à
                            </p>

                            <span>
                                8.6<sup>%</sup>
                                <small>
                                    par an
                                </small>
                            </span>
                        </div>
                    </div>
                </div>

                <p>
                    La pandémie de Covid-19 a d’autant plus servi d’accélérateur : le télétravail s’est imposé, les technologies « sans contact » ont été très plébiscitées, la livraison à distance a explosé… Au point d’entraîner des situations de pénuries dans la chaîne de production des puces électroniques. <strong>Alors que des usines de semi-conducteurs ont dû fermer temporairement l’an dernier, un déséquilibre entre l'offre et la demande a mis la chaîne d'approvisionnement sous pression…</strong>
                </p>

                <Image src={puceSrc} srcRet={puceSrcRet} webp={puceWebp} webpRet={puceWebpRet} alt={`Image d'une puce informatique`} classname={styles.Image}/>
            </div>
        </section>
    )
}
